module.exports = __webpack_public_path__ + "img/estudios-de-caso.11ac4a28.svg";